module.exports = __webpack_public_path__ + "img/word.22965941.png";